//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeProjectsWo', {
//        templateUrl: 'views/components/views/timeProjectsWo/timeProjectsWo.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'workingOrdersService', function ($stateParams, workingOrdersService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let projectKeyno = $stateParams.project_keyno;
            
//            vm.model = {
//                itemsListWorkingOrders: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadWorkingOrders() {
//                vm.model.itemsListWorkingOrders = await workingOrdersService.listCustacts({
//                    cust_name: 'ALL',
//                    cust_no: '0',
//                    project_keyno: projectKeyno,
//                    ok: '0'
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadWorkingOrders();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
